/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmPromptsCreate } from "../../funcs/llmPromptsCreate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreatePromptRequest$inboundSchema,
};

export const tool$llmPromptsCreate: ToolDefinition<typeof args> = {
  name: "llm-prompts-create",
  description: `Create a prompt

Creates a new prompt with its first version. The template supports {{variable}} placeholders.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmPromptsCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
